module.exports = __webpack_public_path__ + "vue-app/img/play-blue-2.f490ea84.svg";